module.exports = __webpack_public_path__ + "static/media/4.35bab370.png";